import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Table, Pagination } from 'react-bootstrap';
import APIserver from '../../../../api/axiosConfig';
import { Link } from 'react-router-dom';

const ReporteVentas = () => {
    const [facturas, setFacturas] = useState([]);
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [totalVentas, setTotalVentas] = useState(0);
    const [totalPagado, setTotalPagado] = useState(0);
    const [totalPendiente, setTotalPendiente] = useState(0);
    const [totalAnulado, setTotalAnulado] = useState(0);
    const [totalVencido, setTotalVencido] = useState(0);
    const [totalPedidos, setTotalPedidos] = useState(0);
    const [totalPedidosPendientes, setTotalPedidosPendientes] = useState(0);
    const [totalProductosVendidos, setTotalProductosVendidos] = useState(0);
    const [totalGananciaProductosVendidos, setTotalGananciaProductosVendidos] = useState(0);
    const [totalVentasPorCliente, setTotalVentasPorCliente] = useState([]);
    const [totalCostoEnvio, setCostoEnvio] = useState(0);
    const [totalFacturasBanco, setTotalFacturasBanco] = useState(0);
    const [totalFacturasEfectivo, setTotalFacturasEfectivo] = useState(0);
    const [totalFacturasContraentrega, setTotalFacturasContraentrega] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0); // Estado para el total de registros
    const [filter, setFilter] = useState("mes");
    const [ventasPorFechaData, setVentasPorFechaData] = useState([]);

    useEffect(() => {
        const today = new Date();

        // Fecha de inicio del mes (primer día)
        const primerDiaMes = new Date(today.getFullYear(), today.getMonth(), 1);
        const fechaInicioMes = primerDiaMes.toISOString().split('T')[0]; // Formato YYYY-MM-DD

        // Fecha de fin del mes (último día)
        const ultimoDiaMes = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const fechaFinMes = ultimoDiaMes.toISOString().split('T')[0];

        setFechaInicio(fechaInicioMes);
        setFechaFin(fechaFinMes);
    }, []);

    // Colores para el gráfico de pastel
    const COLORS = ['#3459e6', '#2fb380', '#f4bd61', '#da292e'];

    // Función para obtener los reportes de la API
    const fetchReportes = async () => {
        try {
            const [ventasRes, pagadoRes, pendienteRes, anuladoRes, vencidoRes, pedidosRes, pedidosPendientesRes, productosVendidosRes, gananciaTotalRes, ventasPorClientesRes, costoEnvioRes, pagadasBancoRes, pagadasEfectivoRes, pagadasContraentregaRes] = await Promise.all([
                APIserver.get('/api/reportes/total-ventas', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-pagado', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-pendiente', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-anulado', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-vencido', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-pedidos', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-pedidos-pendientes', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-productos-vendidos', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-ganancia-productos-vendidosd', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-ventas-por-cliente', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-costo-envio', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-facturas-pagadas-banco', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-facturas-pagadas-efectivo', { params: { fechaInicio, fechaFin } }),
                APIserver.get('/api/reportes/total-facturas-pagadas-contraentrega', { params: { fechaInicio, fechaFin } }),
            ]);

            setTotalVentas(ventasRes.data || { totalFacturas: 0, totalVentas: 0 });
            setTotalPagado(pagadoRes.data || { totalPagado: 0, totalMontoPagado: 0 });
            setTotalPendiente(pendienteRes.data || { totalPendiente: 0, totalMontoPendiente: 0 });
            setTotalAnulado(anuladoRes.data || { totalAnulado: 0, totalMontoAnulado: 0 });
            setTotalVencido(vencidoRes.data || { totalVencido: 0, totalMontoVencido: 0 });
            setTotalPedidos(pedidosRes.data || { totalPedidos: 0 });
            setTotalPedidosPendientes(pedidosPendientesRes.data || { totalPedidosPendientes: 0 });
            setTotalProductosVendidos(productosVendidosRes.data || { totalProductosVendidos: 0 });
            setTotalGananciaProductosVendidos(gananciaTotalRes.data || { totalGananciaProductosVendidos: 0 });
            setTotalVentasPorCliente(ventasPorClientesRes.data || []);
            setCostoEnvio(costoEnvioRes.data || { totalCostoEnvio: 0 });
            setTotalFacturasBanco(pagadasBancoRes.data || { totalFacturasBanco: 0 });
            setTotalFacturasEfectivo(pagadasEfectivoRes.data || { totalFacturasEfectivo: 0 });
            setTotalFacturasContraentrega(pagadasContraentregaRes.data || { totalFacturasContraentrega: 0 });

        } catch (error) {
            console.error("Error fetching report data", error);
        }
    };

    useEffect(() => {
        if (fechaInicio && fechaFin) { // Asegúrate de que ambas fechas estén seleccionadas
            fetchReportes();
        }
    }, [fechaInicio, fechaFin]);

    const handleFiltrar = () => {
        fetchReportes(); // Llama de nuevo a la API con las fechas de filtro actualizadas
    };

    // Función para formatear valores en COP
    const formatCOP = (value) => value?.toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }) || '$0';

    useEffect(() => {
        APIserver.get('/api/reportes/total-obtener-ventas-por-filtro', {
            params: {
                filtro: filter
            }
        })
            .then(response => {
                // Procesar los datos de acuerdo al filtro
                const data = response.data.map(item => {
                    let dateLabel = '';
                    switch (filter) {
                        case 'dia':
                            // Asegurarse de mostrar solo la parte de la fecha (sin la hora)
                            dateLabel = item.date ? new Date(item.date).toISOString().split('T')[0] : '';
                            break;
                        case 'semana': {
                            const { year, week } = item;

                            if (year && week) {
                                // Calcular el primer lunes del año
                                const firstDayOfYear = new Date(`${year}-01-01`);
                                const firstDayOfWeek = firstDayOfYear.getDay(); // Día de la semana: 0 (domingo) a 6 (sábado)

                                // Ajustar al primer lunes del año
                                const offsetDays = firstDayOfWeek === 0 ? -6 : 1 - firstDayOfWeek;
                                const firstMonday = new Date(firstDayOfYear);
                                firstMonday.setDate(firstMonday.getDate() + offsetDays);

                                // Calcular el inicio de la semana específica
                                const startOfWeek = new Date(firstMonday);
                                startOfWeek.setDate(firstMonday.getDate() + (week - 1) * 7);

                                // Limitar al mes actual
                                const month = startOfWeek.getMonth(); // 0 = enero, 1 = febrero, etc.
                                const firstDayOfMonth = new Date(startOfWeek.getFullYear(), month, 1);
                                const lastDayOfMonth = new Date(startOfWeek.getFullYear(), month + 1, 0);

                                // Ajustar al rango del mes si está fuera
                                let adjustedDate = startOfWeek;
                                if (startOfWeek < firstDayOfMonth) {
                                    adjustedDate = firstDayOfMonth; // Si es antes del mes, usar el primer día del mes
                                } else if (startOfWeek > lastDayOfMonth) {
                                    adjustedDate = lastDayOfMonth; // Si es después del mes, usar el último día del mes
                                }

                                // Calcular el número de semana dentro del mes
                                const weekOfMonth = Math.ceil(
                                    (adjustedDate.getDate() - firstDayOfMonth.getDate() + firstDayOfMonth.getDay()) / 7
                                );

                                // Formatear el mes abreviado
                                const monthShort = adjustedDate.toLocaleString('es-CO', { month: 'short' });

                                // Generar etiqueta
                                dateLabel = `Semana ${weekOfMonth}, ${monthShort}`;
                            } else {
                                console.warn(`Datos insuficientes para calcular la semana:`, item);
                                dateLabel = `Semana ${item.week || 'N/A'}, Fecha inválida`;
                            }
                            break;
                        }

                        case 'mes':
                            dateLabel = `${item.month}/${item.year}`;
                            break;
                        case 'ano':
                            dateLabel = `${item.year}`;
                            break;
                        default:
                            dateLabel = item.date;
                    }

                    return { date: dateLabel, ventas: item.ventas };
                });

                setVentasPorFechaData(data);
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }, [filter]); // Se vuelve a ejecutar si el filtro cambia

    const exportarExcel = async () => {
        try {
            // Verificar si las fechas son válidas
            if (!fechaInicio || !fechaFin) {
                alert('Por favor, seleccione un rango de fechas válido.');
                return;
            }

            const response = await APIserver.get('/api/reportes/exportar-excel', {
                params: { fechaInicio, fechaFin },
                responseType: 'arraybuffer',  // Recibimos los datos como un buffer de archivo
            });

            // Crear un Blob con la respuesta para que el navegador lo interprete como un archivo
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            // Crear un enlace temporal para descargar el archivo
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Facturas_${fechaInicio}_a_${fechaFin}.xlsx`; // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            link.remove();  // Elimina el enlace temporal después de hacer clic
        } catch (error) {
            console.error('Error al exportar el Excel:', error);
            alert('Hubo un error al generar el archivo Excel. Por favor, intente nuevamente.');
        }
    };

    useEffect(() => {
        if (fechaInicio && fechaFin) { // Verifica que ambas fechas estén seleccionadas
            fetchFacturas();
        }
    }, [rowsPerPage, currentPage, fechaInicio, fechaFin]); // Dependencias

    const fetchFacturas = async () => {
        try {
            const response = await APIserver.get(`/api/reportes/total-facturas-detalles`, {
                params: {
                    fechaInicio,
                    fechaFin,
                    limit: rowsPerPage, // Número de registros por página
                    offset: (currentPage - 1) * rowsPerPage, // Desplazamiento calculado
                },
            });

            const { results, totalPages } = response.data; // Asegúrate de que el backend envíe `results` y `totalPages`
            setFacturas(results); // Asignar los datos de facturas
            setTotalPages(totalPages); // Total de páginas desde el backend
        } catch (error) {
            console.error('Error al obtener las facturas:', error);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page); // Actualiza la página actual
    };

    // Función para renderizar los botones de paginación
    const renderPaginationItems = () => {
        const items = [];
        const pageRangeDisplayed = 5; // Número de páginas visibles
        let startPage = Math.max(1, currentPage - Math.floor(pageRangeDisplayed / 2));
        let endPage = Math.min(totalPages, startPage + pageRangeDisplayed - 1);

        // Ajustamos si el rango de páginas es menor al rango visible
        if (endPage - startPage < pageRangeDisplayed - 1) {
            startPage = Math.max(1, endPage - pageRangeDisplayed + 1);
        }

        // Mostrar los botones de navegación
        if (startPage > 1) {
            items.push(
                <Pagination.First key="first" onClick={() => handlePageChange(1)} />
            );
        }

        if (currentPage > 1) {
            items.push(
                <Pagination.Prev key="prev" onClick={() => handlePageChange(currentPage - 1)} />
            );
        }

        // Mostrar las páginas dentro del rango visible
        for (let number = startPage; number <= endPage; number++) {
            if (number <= totalPages) {
                items.push(
                    <Pagination.Item
                        key={number}
                        active={number === currentPage}
                        onClick={() => handlePageChange(number)}
                    >
                        {number}
                    </Pagination.Item>
                );
            }
        }

        if (currentPage < totalPages) {
            items.push(
                <Pagination.Next key="next" onClick={() => handlePageChange(currentPage + 1)} />
            );
        }

        if (endPage < totalPages) {
            items.push(
                <Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} />
            );
        }

        return items;
    };

    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value));
        setCurrentPage(1);
    };

    // Función para formatear la fecha en formato DD/MM/YYYY
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses son de 0 a 11
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    };

    return (
        <Container fluid className="py-3">
            {/* Filtros de Reporte */}
            <div className="d-flex flex-column flex-md-row align-items-center align-items-md-end justify-content-center mb-3 text-center">
                <div className="d-flex flex-column me-md-3 mb-3 mb-md-0">
                    <Form.Label>Desde</Form.Label>
                    <Form.Control
                        type="date"
                        value={fechaInicio}
                        onChange={(e) => {
                            const selectedDate = e.target.value;
                            if (new Date(selectedDate) <= new Date(fechaFin || new Date())) {
                                setFechaInicio(selectedDate);
                            }
                        }}
                        max={new Date().toISOString().split("T")[0]} // Fecha máxima: Hoy
                        style={{ minWidth: "200px" }}
                    />
                </div>
                <div className="d-flex flex-column me-md-3 mb-3 mb-md-0">
                    <Form.Label>Hasta</Form.Label>
                    <Form.Control
                        type="date"
                        value={fechaFin}
                        onChange={(e) => {
                            const selectedDate = e.target.value;
                            if (new Date(selectedDate) >= new Date(fechaInicio) && new Date(selectedDate) <= new Date()) {
                                setFechaFin(selectedDate);
                            }
                        }}
                        max={new Date().toISOString().split("T")[0]} // Fecha máxima: Hoy
                        style={{ minWidth: "200px" }}
                    />
                </div>
                {/* Contenedor de botones ajustado */}
                <div className="d-flex align-items-center justify-content-end mt-3 mt-md-0">
                    <Button variant="danger" onClick={exportarExcel}>
                        Exportar
                    </Button>
                </div>
            </div>

            {/* Resumen de Ventas Totales */}
            <Row className="mb-4 text-center g-4">
                {[
                    {
                        bg: "light",
                        title: `Cantidad Facturas (${totalVentas.totalFacturas || 0})`,
                        value: formatCOP(totalVentas.totalVentas || 0),
                    },
                    {
                        bg: "light",
                        title: `Total Pagado (${totalPagado.totalPagado || 0})`,
                        value: formatCOP(totalPagado.totalMontoPagado || 0),
                    },
                    {
                        bg: "light",
                        title: `Total Pendiente (${totalPendiente.totalPendiente || 0})`,
                        value: formatCOP(totalPendiente.totalMontoPendiente || 0),
                    },
                    {
                        bg: "light",
                        title: `Total Vencido (${totalVencido.totalVencido || 0})`,
                        value: formatCOP(totalVencido.totalMontoVencido || 0),
                    },
                ].map((item, idx) => (
                    <Col key={idx} xs={12} sm={6} md={3}>
                        <Card bg={item.bg} className="text-dark shadow-sm h-100">
                            <Card.Body>
                                <Card.Title>{item.title}</Card.Title>
                                <h4>{item.value}</h4>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* Estadísticas de Pedidos */}
            <Row className="mb-4 g-4">
                {[
                    {
                        title: `Total Productos: ${totalProductosVendidos.totalProductosVendidos || 0}`,
                        subtitle: `Total Ganancia: ${formatCOP(totalGananciaProductosVendidos.totalGananciaProductosVendidos || 0)}`,
                    },
                    {
                        title: `Total Envio: ${formatCOP(totalCostoEnvio.totalCostoEnvio || 0)}`,
                        subtitle: `Total Banco: ${formatCOP(totalFacturasBanco.totalFacturasBanco || 0)}`,
                    },
                    {
                        title: `Total Efectivo: ${formatCOP(totalFacturasEfectivo.totalFacturasEfectivo || 0)}`,
                        subtitle: `Total Contraentrega: ${formatCOP(totalFacturasContraentrega.totalFacturasContraentrega || 0)}`,
                    },
                    {
                        title: `Facturas Anuladas (${totalAnulado.totalAnulado || 0})`,
                        subtitle: formatCOP(totalAnulado.totalMontoAnulado || 0),
                    },
                ].map((item, idx) => (
                    <Col key={idx} xs={12} sm={6} md={3}>
                        <Card className="shadow-sm h-100 text-dark">
                            <Card.Body>
                                <Card.Title>{item.title}</Card.Title>
                                {item.subtitle && <Card.Title>{item.subtitle}</Card.Title>}
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            <div style={{ boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)" }}>
                <Table responsive className="text-center align-middle border">
                    <thead>
                        <tr>
                            <th colSpan={10}>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <Form.Select
                                            className='ms-2'
                                            value={rowsPerPage}
                                            onChange={handleChangeRowsPerPage}
                                        >
                                            <option value='5'>5</option>
                                            <option value='10'>10</option>
                                            <option value='20'>20</option>
                                            <option value='50'>50</option>
                                        </Form.Select>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th>Factura</th>
                            <th>Cliente</th>
                            <th>Creacion</th>
                            <th>Forma Pago</th>
                            <th>Envio</th>
                            <th>Transportadora</th>
                            <th>Total</th>
                            <th>Productos</th>
                            <th>Pagado</th>
                            <th>Ganancia</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(facturas) && facturas.length > 0 ? (
                            facturas.map((factura) => (
                                <tr key={factura.idFactura}>
                                    <td>
                                        <Link
                                            to={`/admin/Facturas/DetallesFactura/${factura.idFactura}/`}
                                            className="text-decoration-none"
                                        >
                                            {factura.numeroFactura}
                                        </Link>
                                    </td>
                                    <td>
                                        <Link
                                            to={`/admin/Clientes/DetallesClientes/${factura.idCliente}/`}
                                            className="text-decoration-none"
                                        >
                                            {factura.clienteNombre}
                                        </Link>
                                    </td>
                                    <td>{formatDate(factura.fechaCreacion)}</td>
                                    <td>{factura.formaPago}</td>
                                    <td>{formatCOP(factura.cosEnvio)}</td>
                                    <td>{factura.transportadora}</td>
                                    <td>{formatCOP(factura.total)}</td>
                                    <td>{factura.totalProductos}</td>
                                    <td>{formatCOP(factura.pagado)}</td>
                                    <td>{formatCOP(factura.gananciaTotal)}</td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={10}>No hay facturas disponibles.</td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={10}>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <Pagination>
                                        {renderPaginationItems()}
                                    </Pagination>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        </Container>
    );
};

export default ReporteVentas;
